import {ProjectType} from '../types/project';

// The ID of the template presentation, containing all placeholders for the content
// Link: https://docs.google.com/presentation/d/1RmaUvHgskA8S-cT2JAkgl9r9KB8YdctAHY6qUvkyw6U/
export const SINGLE_PROJECT_PRESENTATION_TEMPLATE =
  '1RmaUvHgskA8S-cT2JAkgl9r9KB8YdctAHY6qUvkyw6U';

// The IDs of the text project slides
export const TEMPLATE_PROJECT_SLIDES_IDS = {
  title: 'gccd1fa2f85_1_27',
  description_de: 'g148df68eab9_0_36',
  description_en: 'g148df68eab9_0_36',
  teamAndLinks: 'g148df68eab9_0_7'
};
export const TEMPLATE_DEVELOPMENT_PROJECT_SLIDE_ID = 'g148df68eab9_0_0';
export const TEMPLATE_CONSULTING_PROJECT_SLIDE_ID = 'g148df68eab9_0_14';

// The ID of the diamond slide
export const TEMPLATE_DIAMOND_SLIDE_ID = 'g148df68eab9_0_21';

// The IDs of the image slides
export const TEMPLATE_IMAGE_SLIDES_IDS = {
  portrait: 'gccd1fa2f85_1_90',
  landscape: 'gd41adfb883_0_12'
};

// The ID of the related projects slide
export const TEMPLATE_RELATED_PROJECTS_SLIDE_ID = 'g145ca974c81_0_0';

// The IDs of the confidential badges on the project slides
export const CONFIDENTIAL_BADGE_IDS = {
  title: 'gd41adfb883_0_40',
  description_de: 'g148df68eab9_0_40',
  description_en: 'g148df68eab9_0_40',
  [ProjectType.DEVELOPMENT]: 'g148df68eab9_0_4',
  [ProjectType.CONSULTING]: 'g148df68eab9_0_18',
  teamAndLinks: 'g148df68eab9_0_11',
  diamond: 'g148df68eab9_0_24',
  image: {
    portrait: 'gd41adfb883_0_47',
    landscape: 'gd41adfb883_0_48'
  },
  relatedProjects: 'g145ca974c81_0_4'
};

export const DRIVE_FOLDER_NAME = 'Project Gallery Exports';
